import axios from "axios";
import store from "@/store";

let url = process.env.VUE_APP_URL || '';

if (typeof window.meedu_app_url !== 'undefined' && window.meedu_app_url) {
    url = window.meedu_app_url;
}

let request = axios.create()

request.defaults.baseURL = url;
request.defaults.timeout = 10000;
request.defaults.withCredentials = false;
// 请求拦截器(附带上token)
request.interceptors.request.use(
    (config) => {
        config.headers.Authorization= "Bearer " + localStorage.getItem("token") 
        return config;
    },
    (error) => {
        return Promise.error(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    (response) => {
        if (response.data.code == 0 || response.data.code == 1 || !('code' in response.data))
            return Promise.resolve(response.data)
        else
            return Promise.reject(response)
    },
    // 当http的状态码非2xx
    (error) => {
        return Promise.reject(error.response);
    }
);

export function get(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        request
            .get(url, {
                params: params,
                ...config
            })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function post(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        request
            .post(url, params, config)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function del(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        request
            .delete(url, {
                params: params,
                ...config
            })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                resolve(err);
            });
    });
}

